import { Error } from '@/components/Error'
import { Typography } from '@/components/Typography'

import styles from './notfound.module.css'

export default function Notfound() {
  return (
    <div className={styles.page}>
      <Error title="Fatal Error" style={{ width: '300px' }}>
        <Typography variant="paragraph" pixelated>
          404 Page Not Found
        </Typography>
      </Error>
    </div>
  )
}
